import React, { useEffect, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { useIntl } from 'react-intl';

import TextFieldDefault from '../../Posts/Forms/TextFieldDefault';
import { debounceFactory } from '../../../Utils';

const debounce = debounceFactory(300);

function SearchBox({ value, onChange, error }: any) {
  const [debouncedQuery, setDebouncedQuery] = useState(value);
  const intl = useIntl();

  useEffect(() => {
    debounce(() => onChange('q', debouncedQuery));
  }, [debouncedQuery]);

  const clear = debouncedQuery ? (
    <IconButton
      onClick={() => setDebouncedQuery(null)}
      size="large"
      aria-label={intl.formatMessage({ id: 'BUTTONS.CLEAR' })}
    >
      <ClearIcon color="disabled" />
    </IconButton>
  ) : (
    <span />
  );

  return (
    <TextFieldDefault
      value={debouncedQuery}
      onChange={(e: any) => setDebouncedQuery(e.target.value)}
      placeholder={intl.formatMessage({ id: 'SEARCH.INPUT_PLACEHOLDER' })}
      slotProps={{
        htmlInput: { 'aria-label': 'search', autoComplete: 'off' },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="disabled" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" alt={intl.formatMessage({ id: 'BUTTONS.CLEAR' })}>
              {clear}
            </InputAdornment>
          ),
        },
      }}
      error={error}
      fullWidth
    />
  );
}

export default SearchBox;
